import * as HLF from "html-living-framework";
import * as Constants from "../Data/Constants";
import * as SoundEffect from "../Data/SoundEffect";
import * as Topics from "../Data/Topics";

export class PaintButton extends HLF.Input.Selectable {
    public static readonly COLOUR_DEFAULT: number = 0xFFFFFF;

    private _bg: PIXI.Sprite;
    private _fill: PIXI.Sprite;
    private _colour: number;

    constructor(pColour: number) {
        super();
        this._colour = pColour;

        this._bg = HLF.PixiUtils.makeSprite("button-paint-bg", Constants.SPRITESHEET_UI);
        this._visuals.addChild(this._bg);

        this._fill = HLF.PixiUtils.makeSprite("button-paint-fill", Constants.SPRITESHEET_UI);
        this._fill.tint = this._colour;
        this._visuals.addChild(this._fill);

        this.hitArea = new PIXI.Rectangle(
            -this._bg.width * 0.5,
            -this._bg.height * 0.5,
            this._bg.width,
            this._bg.height,
        );

        this._clickedSfx = SoundEffect.UI_CLICK;
    }

    public get colour(): number {
        return this._colour;
    }

    public set colour(pValue: number) {
        this._colour = pValue;
        this._fill.tint = this._colour;
    }

    public select(): void {
        super.select();
        this._bg.scale.set(1.1);
        this._fill.scale.set(this._bg.scale.x);
        this._bg.tint = 0xAAAAAA;
        HLF.PixiUtils.sendToFront(this);
    }

    public deselect(): void {
        super.deselect();
        this._bg.scale.set(1.0);
        this._fill.scale.set(this._bg.scale.x);
        this._bg.tint = 0xFFFFFF;
    }

    public onFocusBegin(): void {
        PubSub.publishSync(Topics.KEYBOARD_FOCUS_BEGIN, this);
    }

    public onFocusEnd(): void {
        PubSub.publishSync(Topics.KEYBOARD_FOCUS_END, this);
    }

    public getFocusPosition(): PIXI.Point {
        return this.getGlobalPosition();
    }

    public getFocusSize(): PIXI.Point {
        return new PIXI.Point(this.width, this.height);
    }
}
